import { useEffect, useState } from "react";
import axios from "axios";
import { Download, Inbox } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPES = [
  { key: "consultation", label: "Consultations" },
  { key: "partner_application", label: "Partner Applications" },
  { key: "risk_snapshot", label: "Risk Snapshots" },
];

// Read-only export of stored submissions for future CRM import (not a CRM).
export const AdminSubmissions = ({ headers }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/consultations`, { headers, params: { limit: 5000 } }).then((r) => setItems(r.data)).catch(() => setItems([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const download = (key) => {
    const rows = (items || []).filter((i) => i.type === key);
    const blob = new Blob([JSON.stringify(rows, null, 2)], { type: "application/json" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `btr-${key}-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="btr-glass rounded-2xl p-6 sm:p-8 mt-8" data-testid="admin-submissions">
      <div className="flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase font-display text-zinc-500">
        <Inbox className="w-3.5 h-3.5" /> Stored Submissions · Export
      </div>
      <div className="grid sm:grid-cols-3 gap-3 mt-5">
        {TYPES.map((t) => {
          const count = items ? items.filter((i) => i.type === t.key).length : "…";
          return (
            <div key={t.key} className="bg-[#0a0a0a] border border-white/8 rounded-lg p-4">
              <div className="font-display font-extrabold text-white text-3xl" data-testid={`admin-count-${t.key}`}>{count}</div>
              <div className="text-zinc-400 text-xs mt-1">{t.label}</div>
              <button onClick={() => download(t.key)} disabled={!items} className="mt-3 inline-flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase font-display text-[#ff4d55] hover:text-white transition-colors" data-testid={`admin-export-${t.key}`}>
                <Download className="w-3 h-3" /> Export JSON
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
